import React, { useState, useEffect } from "react";
import { Modal, Typography, Row, Col, Divider, Checkbox, Button } from "antd";

const { Title, Text } = Typography;
export default function CustomiseFieldModal({
  showModal,
  closeModal,
  tableData,
  handleDone,
}) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (tableData) {
      setData(tableData);
    }
  }, [tableData]);

  const onChangeCheckbox = (e, id) => {
    const newData = data.columns?.map((item) =>
      item.attribute_id === id ? { ...item, visible: e.target.checked } : item
    );
    setData({ ...data, columns: newData });
  };
  const save = () => {
    handleDone(data);
  };
  return (
    <div>
      {data && data?.columns ? (
        <Modal
          visible={showModal}
          onCancel={closeModal}
          closable={false}
          closeIcon={null}
          footer={null}
          centered
          width={"45em"}
          bodyStyle={{ padding: "2em" }}
        >
          <Row>
            <Col span={24}>
              <Title level={4}>Customize details</Title>
              <Text>Select the details you want to show in this catalogue</Text>
            </Col>
          </Row>
          <Divider style={{ margin: "1em" }} />

          <Row style={{ maxHeight: "30em", overflowY: "scroll" }}>
            {data &&
              data?.columns?.map(
                (item, index) =>
                  item?.is_internal === false &&
                  item?.attribute_id && (
                    <Col span={12} key={index} style={{ padding: 5 }}>
                      <Checkbox
                        checked={item?.visible}
                        onChange={(e) =>
                          onChangeCheckbox(e, item?.attribute_id)
                        }
                      >
                        {item?.name}
                      </Checkbox>
                    </Col>
                  )
              )}
          </Row>
          <Divider style={{ margin: "1em" }} />
          <Row style={{ marginTop: "1.5em" }} justify="end">
            <Col span={6}>
              <Button
                onClick={save}
                type="primary"
                size="large"
                style={{
                  background: "#1D2624",
                  border: "1px solid #1D2624",
                  color: "#fff",
                  width: "100%",
                }}
              >
                Done
              </Button>
            </Col>
          </Row>
        </Modal>
      ) : (
        <></>
      )}
    </div>
  );
}
